export default {
      id: "facebook-flat-usage",
      viewBox: "0 0 15 26",
      url: __webpack_public_path__ + "img/icons.ec9c9113.svg#facebook-flat",
      toString: function () {
        return this.url;
      }
    }